module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Down-right-d4de4c521016ef627a7e9dce2d1adf7b.svg";